'use client'
import React, { HTMLAttributes, ReactNode } from 'react'

export interface DataListRowProps extends HTMLAttributes<HTMLLIElement> {
    children: ReactNode
}

export const DataListRow = ({ children, ...rest }: DataListRowProps): JSX.Element => (
    <li {...rest} className={rest.className ?? ''}>
        <ul className="w-full flex px-3" role="row">
            {children}
        </ul>
    </li>
)
